import { mapActions } from 'vuex';

export default {
  methods: {
    ...mapActions('configuration', ['setProductQuantity', 'resetContainerChoice']),
    chooseContainer(container) {
      this.resetContainerChoice();
      this.setProductQuantity({ product: container, quantity: 1 });
      this.$router.push('/uni-baies/resume');
    },
  },
};
